import { Center, Loader, Stack, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

interface LoadingStateProps {
  label?: string;
  height?: number | string;
}

export function LoadingState({ label, height = 240 }: LoadingStateProps) {
  const { t } = useTranslation('common');
  return (
    <Center h={height} role="status" aria-busy>
      <Stack align="center" gap="xs">
        <Loader />
        <Text c="dimmed">{label ?? t('state.loading')}</Text>
      </Stack>
    </Center>
  );
}
